import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";

export default function SearchSubcategory({ setSearch, search , placeholder}) {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(searchText); // 🔥 triggers API call in parent
    }, 500);

    return () => clearTimeout(handler);
  }, [searchText]);

  return (
    <div className="hire-first">
      <div className="col-lg-5 mx-auto">
        <div className="search-bar">
          <input
            type="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder='Search Categories'
            className="form-control"
          />
          <button className="btn search-btn">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
              alt=""
            />
          </button>
        </div>
      </div>
    </div>
  );
}
